import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './FounderLetter.module.scss';
import LetterSVG from './LetterSVG';

const FounderLetter = () => {
    const navigate = useNavigate();

    const handleReadMore = () => {
        navigate('/pricing');
        setTimeout(() => {
            const el = document.getElementById('pricing-letter');
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 150);
    };

    return (
        <section id="founder-letter" className={styles.founderLetter} aria-label="Founder Letter">
            {/* Left — SVG letter illustration */}
            <div className={styles.avatarWrapper}>
                <div className={styles.arc} aria-hidden="true" />
                <div className={styles.avatarCircle}>
                    <LetterSVG />
                </div>
            </div>

            {/* Right — letter content */}
            <div className={styles.letterContent}>
                <h2 className={styles.heading}>Dear Prepal Founding Members,</h2>
                <p className={styles.body}>
                    Thank you for reading this far and hopefully Prepal was able to pique your
                    interest. If we managed to convince you to trust us and want to tag along,
                    then you might want to read below to understand a couple more things.
                </p>
                <button
                    className={styles.readMoreBtn}
                    onClick={handleReadMore}
                >
                    Read more
                </button>
            </div>
        </section>
    );
};

export default FounderLetter;
